import type { JSX } from 'react';

import SvgIcon from '@mui/material/SvgIcon';

interface Props {
    color?: string;
    size?: number;
}

export const CustomDiscoverTune = ({ color, size = 20 }: Props): JSX.Element => (
    <SvgIcon style={{ width: size, height: size }} viewBox={`0 0 ${size} ${size}`}>
        <path
            d="M10.9769 7.5V5.83333H13.4769V2.5H15.1436V5.83333H17.6436V7.5H10.9769ZM13.4769 17.5V9.16667H15.1436V17.5H13.4769ZM5.14355 17.5V14.1667H2.64355V12.5H9.31022V14.1667H6.81022V17.5H5.14355ZM5.14355 10.8333V2.5H6.81022V10.8333H5.14355Z"
            fill={color}
        />
    </SvgIcon>
);
